import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

export const MarkdownShortcuts = Extension.create({
  name: 'markdownShortcuts',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('markdownShortcuts'),
        props: {
          handleKeyDown: (view, event) => {
            const { state } = view
            const { selection } = state
            const { $from } = selection

            // Only handle at the start of a line
            if ($from.parentOffset !== 0) {
              return false
            }

            const textBefore = $from.parent.textContent.slice(0, $from.parentOffset)
            const lineStart = textBefore.split('\n').pop() || ''

            // Heading shortcuts (# ## ###)
            if (/^#{1,6}\s$/.test(lineStart)) {
              const level = lineStart.length - 1
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.setBlockType($from.pos - lineStart.length, $from.pos, state.schema.nodes.heading, { level })
              view.dispatch(tr)
              return true
            }

            // Bold shortcut (**text**)
            if (/^\*\*.*\*\*$/.test(lineStart)) {
              const text = lineStart.slice(2, -2)
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.insertText(text)
              tr.addMark($from.pos - text.length, $from.pos, state.schema.marks.strong)
              view.dispatch(tr)
              return true
            }

            // Italic shortcut (*text*)
            if (/^\*.*\*$/.test(lineStart) && !lineStart.startsWith('**')) {
              const text = lineStart.slice(1, -1)
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.insertText(text)
              tr.addMark($from.pos - text.length, $from.pos, state.schema.marks.em)
              view.dispatch(tr)
              return true
            }

            // Unordered list shortcut (- item)
            if (/^-\s$/.test(lineStart)) {
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.setBlockType($from.pos - lineStart.length, $from.pos, state.schema.nodes.bulletList)
              view.dispatch(tr)
              return true
            }

            // Ordered list shortcut (1. item)
            if (/^\d+\.\s$/.test(lineStart)) {
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.setBlockType($from.pos - lineStart.length, $from.pos, state.schema.nodes.orderedList)
              view.dispatch(tr)
              return true
            }

            // Blockquote shortcut (> text)
            if (/^>\s$/.test(lineStart)) {
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.setBlockType($from.pos - lineStart.length, $from.pos, state.schema.nodes.blockquote)
              view.dispatch(tr)
              return true
            }

            // Code block shortcut (```)
            if (/^```$/.test(lineStart)) {
              const tr = state.tr
              tr.delete($from.pos - lineStart.length, $from.pos)
              tr.setBlockType($from.pos - lineStart.length, $from.pos, state.schema.nodes.codeBlock)
              view.dispatch(tr)
              return true
            }

            return false
          },
        },
      }),
    ]
  },
})
